export default function SummaArvotFooter() {
  return <span className={'footer'}>Lähde: TAPIO Summa-arvotaulukot 2026</span>;
};
